<div class="card mt-1">
  <div class="card-body">
    <app-verification-heading
      [patientAttachment]="patientAttachment"
      title="Validate Patient Match"
    />
    <app-patient-details [capture]="capture" />
    <app-patient-match-form [capture]="capture" [patientAttachment]="patientAttachment" />
  </div>
</div>
